import { render, staticRenderFns } from "./socail-security-number.vue?vue&type=template&id=da3ffd74&"
import script from "./socail-security-number.vue?vue&type=script&lang=js&"
export * from "./socail-security-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports